// const activitySlider = document.querySelector(
//   "input[type='range'][name='activity']"
// );
const activityOutput = document.querySelector("label[for='activity']");
const activityOutputDescription = document.querySelector("label.description[for='activity']");

// const weightSlider = document.querySelector(
//   "input[type='range'][name='weightgroup']"
// );
const weightOutput = document.querySelector("label[for='weight']");
const weightOutputDescription = document.querySelector("label.description[for='weightgroup']");

// const treatsSlider = document.querySelector(
//   "input[type='range'][name='treats']"
// );
const treatsOutput = document.querySelector("label[for='treats']");
const treatsOutputDescription = document.querySelector("label.description[for='treats']");

const setWeightFromValue = value => {
  let weight;
  let description;

  switch (Number(value)) {
    case 1:
      weight = "A bit skinny";
      description = "Narrow waistline and you can clearly see the ribs.";
      break;
    case 2:
      weight = "Just pawfect";
      description = "Visible waistline with some fat cover but the ribs are easy to feel.";
      break;
    case 3:
      weight = "A bit chubby";
      description = "Waistline is not visible and the ribs are hard to feel.";
      break;

    default:
      weight = "Just pawfect";
      description = "Visible waistline with some fat cover but the ribs are easy to feel.";
      break;
  }

  var obj = {
    answer: weight,
    weight: weight,
    description: description
  };

  return obj;
};

const setActivityFromValue = value => {
  let activity;
  let description;

  switch (Number(value)) {
    case 1:
      activity = "Pretty snoozy";
      description = "0-30 min walks per day";
      break;
    case 2:
      activity = "Active";
      description = "30-90 min walks per day";
      break;
    case 3:
      activity = "An explosion of energy";
      description = "90+ min walks per day";
      break;

    default:
      activity = "Active";
      description = "30-90 min walks per day";
      break;
  }

  var obj = {
    answer: activity,
    activity: activity,
    description: description
  };

  return obj;
};

const setTreatsFromValue = value => {
  let treats;
  let description;

  switch (Number(value)) {
    case 1:
      treats = "Never";
      description = "Keeping it clean! Doesn't eat any";
      break;
    case 2:
      treats = "Sometimes";
      description = "1-3 times a day";
      break;
    case 3:
      treats = "Pretty often";
      description = "4+ times a day";
      break;

    default:
      treats = "Sometimes";
      description = "1-3 times a day";
      break;
  }

  var obj = {
    answer: treats,
    treats: treats,
    description: description
  };

  return obj;
};

// weightOutput.innerHTML = setWeightFromValue().weight;
// weightOutputDescription.innerHTML = setWeightFromValue().description;
// activityOutput.innerHTML = setActivityFromValue().activity;
// activityOutputDescription.innerHTML = setActivityFromValue().description;
// treatsOutput.innerHTML = setTreatsFromValue().treats;
// treatsOutputDescription.innerHTML = setTreatsFromValue().description;

// weightSlider.oninput = function() {
//   weightOutput.innerHTML = setWeightFromValue(this.value).weight;
//   weightOutputDescription.innerHTML = setWeightFromValue(this.value).description;
// };

// activitySlider.oninput = function() {
//   activityOutput.innerHTML = setActivityFromValue(this.value).activity;
//   activityOutputDescription.innerHTML = setActivityFromValue(this.value).description;
// };

// treatsSlider.oninput = function() {
//   treatsOutput.innerHTML = setTreatsFromValue(this.value).treats;
//   treatsOutputDescription.innerHTML = setTreatsFromValue(this.value).description;
// };

export { setActivityFromValue, setTreatsFromValue, setWeightFromValue };

